import { ProductTier, useProductTier } from "@/hooks/useProductTier";
import { productTierColors } from "@/components/product-tier-utils";

export const ProductTierBadge = ({
  tierOverride,
}: {
  tierOverride?: ProductTier;
}): JSX.Element => {
  const productTier = useProductTier();

  const finalTier = tierOverride ?? productTier;

  const name = {
    base: "Base",
    base_PAID: "Base",
    __deprecated__pro: "Pro",
    payg: "Pay As You Go",
    enterprise: "Enterprise",
  }[finalTier];

  const classes = productTierColors(finalTier);

  return (
    <div
      className={`w-fit px-1.5 py-0.5 font-mono text-[10px] tracking-[0.08em] uppercase ${classes.bg} ${classes.text}`}
    >
      {name}
    </div>
  );
};
